import React from 'react';

const markup = String.raw`<div class="card">
<div class="card-head"><p class="card-title">Performance trend</p><span class="click-tag">Click a point ↓</span></div>
<div class="chart-wrap inline-style-40"><canvas aria-label="Line chart of this vendor's performance score over the last 6 months, clickable points filter orders and show that month's feedback" id="vendPerfTrend" role="img"></canvas></div>
<p class="inline-style-52" id="vendFeedback">Feedback: Strong on-time performance, minor packaging note on PO1002.</p>
</div>`;

export default function PerformanceTrendCard() {
  return <div className="raw-fragment" dangerouslySetInnerHTML={{ __html: markup }} />;
}
